import { Box, styled } from "@mui/material"
import React from "react"

const ScheduleMeetingDialogHeader = (props: { children: React.ReactNode }) => (
  <_Container>{props.children}</_Container>
)

export default ScheduleMeetingDialogHeader

const _Container = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  flexWrap: "nowrap",

  paddingTop: 24,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 4,

  width: "100%",
}) as typeof Box
